<template>
  <v-dialog persistent :value="deletePopup" width="800">
    <v-card color="primary" class="elevation-0 text-xs-left">
      <v-card-title class="px-4 py-2">
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 lg6>
            <h2 class="py-3 font-weight-regular primary text-uppercase white--text">ARE YOU SURE?</h2>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
    <v-card class="elevation-0 pt-4">
      <h2 class="font-weight-bold mb-4 heading-with-border relative pb-3">Are you sure want to remove {{ deleteObj.first_name }} from your organization ?</h2>
      <div class="pb-3 text-xs-right px-4">
        <v-btn
        depressed
        @click="closeModal()"
        fab 
        color="white"
        :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
      >
        <v-icon dark class="primary--text">close</v-icon>
      </v-btn>
      <v-btn
      depressed
        @click="deleteItem()"
        fab 
        color="white"
        :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
      >
        <v-icon dark class="primary--text">check</v-icon>
      </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {
  
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      deletePopup: 'user/delete',
      deleteObj: 'user/deleteObj',
    }),
  },
  

  created() {
    this.closeModal();
  },

  methods: {
    /**
     * Delete user from organization
     */
    deleteItem() {

      this.spinner(true);
      const url = `${Env.url}/api/account/${this.deleteObj.account_id}`;
      AuthApi.deleteApi(url)
        .then((res) => {
          this.fetchAllUsers();
          this.snackbar({
            text: 'Successfully deleted.',
            timeout: 4000,
            open: true,
          });
          this.spinner(false);
          this.closeModal();

        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: 'Please try again later.',
            timeout: 4000,
            open: true,
          });
        });
    },

    /**
     * Fetch new user list
     */

    fetchAllUsers() {

      return false;
      // TODO LATER
      const url = `${Env.url}/api/users`;
      AuthApi.postApi(url, {
        records_per_page: 100,
        page_number: 1,
      })
      .then((res) => {
        const rawData = res.data.payload.users;
        const users = [];
        rawData.map((list) => {
        // Lets push user account id inside the user obj
          const listVal = list.users;
          listVal.account_id = list.account_id;
          listVal.is_corporate = list.account.is_corporate;
          users.push(listVal);
        });
        this.setUserlist(users);
      })
      .catch(() => {
      });
    },


    closeModal() {
      this.setUserDelete(false);
      this.setUserDeleteObj({});
    },

    ...mapActions({
      setUserDelete: 'user/setDelete',
      setUserlist: 'user/setList',
      setUserDeleteObj: 'user/setDeleteObj',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>


